import FeatureController from '../FeatureController';

export default class ActivityController extends  FeatureController{

    constructor(panel, $state, $location) {
      super(panel, $state);
      this.$location = $location;

      this.matches = [];
      this.views = [];
      this.favourites = [];
      this.likes = [];
      const self = this;

      this.panel.get('/v1/activity/feed', (response) => {
        if (panel.okay(response)) {
          self.matches = response.feed.matches;
          self.views = response.feed.views;
          self.favourites = response.feed.favourites;
          self.likes = response.feed.likes;
        }
      });

      let elem = new Foundation.Tabs($("#activity-tabs"), {});
    }

    size (activity_id, them) {

        let activity_source = !them ? 'activity' : 'activity_news';
        if (typeof this.dashboard !== 'undefined') {
            for (let i in this.dashboard[activity_source]) {
                if (this.dashboard[activity_source][i].activity_id == activity_id) {
                    return this.dashboard[activity_source][i].size;
                }
            }
        }
        return 0;
    }

    loader (activity_id, them, icon) {

        var pb = $('.popup-activity-items');

        if (!pb.hasClass('popup-loader')) {

            this.activity.ilog_size = this.ilog.length;

            pb.addClass('popup-loader');

            var page = 0;

            this.activity.is_loading_activity = false;

            pb.scroll(function () {

                if (!this.activity.is_loading_activity) {
                    this.activity.is_loading_activity = true;
                    this.activity.popup(activity_id, them, icon, ++page);
                }
            });
        }
    }

    update (page) {

        if (!this.activities_size) {
            this.activities_size = this.activities.size;
        }

        var url = '/v1/activity/user?activity_id=' + this.selected;

        if (page) {
            url += '&page=' + page;
        } else {
            this.page = 0;
        }

        const self = this;

        this.panel.get(url, function (response) {

            if (self.panel.okay(response)) {

                if (page) {
                    if (response.log.size >= self.activities_size) {
                        self.fetching = false;
                    }
                    self.activities = self.activities.concat(response.log);
                } else {
                    self.fetching = false;
                    self.activities = response.log;
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/features/activity/ActivityController.js